// features/public-filters/domain/mappers/storiesMapper.ts
import { Range } from '../FilterTypes';

/**
 * Parse a stories display string into a numeric value
 * @param value - Display string like "1", "5", "No min", "No max"
 * @returns Numeric value or null for unbounded
 */
export function parseStoriesValue(value: string): number | null {
  if (value === 'No min' || value === 'No max') return null;
  // stories can be a decimal
  const parsed = parseFloat(value);
  return isNaN(parsed) ? null : parsed;
}

/**
 * Format a numeric stories value for display
 * @param value - Numeric value or null
 * @param isMin - Whether this is a min or max value
 * @returns Display string
 */
export function formatStoriesValue(value: number | null, isMin: boolean): string {
  if (value === null) return isMin ? 'No min' : 'No max';
  return value.toString();
}

/**
 * Apply stories change from dropdown selection
 * @param currentRange - Current stories range
 * @param type - Whether changing min or max
 * @param value - New display value from dropdown
 * @returns New Range with updated value
 */
export function applyStoriesChange(
  currentRange: Range,
  type: 'min' | 'max',
  value: string,
): Range {
  const numericValue = parseStoriesValue(value);

  if (type === 'min') {
    return Range.create(numericValue, currentRange.max);
  } else {
    return Range.create(currentRange.min, numericValue);
  }
}
